function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "21.7344142%",
  y1: "48.2631189%",
  x2: "130.610154%",
  y2: "55.4492484%",
  id: "linearGradient-1-pdrTop"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  stopOpacity: 0.989470109,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})), React.createElement("path", {
  d: "M4.39999998,0 L83.1599995,0 C85.5900524,8.18688866e-15 87.5599995,1.96994709 87.5599995,4.39999998 L87.5599995,18.4799999 C87.5599995,20.9100528 85.5900524,22.8799999 83.1599995,22.8799999 L4.39999998,22.8799999 C1.96994709,22.8799999 2.45591618e-15,20.9100528 0,18.4799999 L0,4.39999998 C-2.97595649e-16,1.96994709 1.96994709,4.46393473e-16 4.39999998,0 Z",
  id: "path-2-pdrTop"
}), React.createElement("filter", {
  x: "-37.7%",
  y: "-144.2%",
  width: "175.4%",
  height: "388.5%",
  filterUnits: "objectBoundingBox",
  id: "filter-3-pdrTop"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 11,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.316471554   0 0 0 0 0.506602588   0 0 0 0 0.728289753  0 0 0 0.246773098 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), React.createElement("path", {
  d: "M4.39999998,27.2799999 L83.1599995,27.2799999 C85.5900524,27.2799999 87.5599995,29.2499469 87.5599995,31.6799998 L87.5599995,89.7599995 C87.5599995,92.1900524 85.5900524,94.1599995 83.1599995,94.1599995 L4.39999998,94.1599995 C1.96994709,94.1599995 3.72605829e-15,92.1900524 0,89.7599995 L0,31.6799998 C-1.18577407e-15,29.2499469 1.96994709,27.2799999 4.39999998,27.2799999 Z",
  id: "path-4-pdrTop"
}), React.createElement("filter", {
  x: "-37.7%",
  y: "-49.3%",
  width: "175.4%",
  height: "198.7%",
  filterUnits: "objectBoundingBox",
  id: "filter-5-pdrTop"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 11,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.316471554   0 0 0 0 0.506602588   0 0 0 0 0.728289753  0 0 0 0.246773098 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-pdrTop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "21-desktop-UI-pdrTop",
  transform: "translate(-458.000000, -315.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-18-pdrTop",
  transform: "translate(420.000000, 157.000000)"
}, React.createElement("g", {
  id: "Group-15-pdrTop",
  transform: "translate(60.000000, 180.000000)"
}, React.createElement("g", {
  id: "Rectangle-14-pdrTop"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3-pdrTop)",
  xlinkHref: "#path-2-pdrTop"
}), React.createElement("use", {
  fill: "url(#linearGradient-1-pdrTop)",
  xlinkHref: "#path-2-pdrTop"
})), React.createElement("g", {
  id: "Rectangle-14-pdrTop"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-5-pdrTop)",
  xlinkHref: "#path-4-pdrTop"
}), React.createElement("use", {
  fill: "#FFFFFF",
  xlinkHref: "#path-4-pdrTop"
}))))));

var SvgPdrTop = function SvgPdrTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "131px",
    height: "138px",
    viewBox: "0 0 131 138",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdrTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdrTop.99fed9d9.svg";
export { ForwardRef as ReactComponent };